import { useTheme } from '@Theme';
import { css } from 'aphrodite';
import * as React from 'react';
import { PaperPlaneIcon } from '../../svgs/icons/PaperPlaneIcon';
import { styleSheet } from './styles';

interface ISendATestButtonProps {
	disabled?: boolean;
	onClick: () => void;
}

/** The campaign composer's "Send a Test" control, shared so the automation email dialogs look and act the same. */
export function SendATestButton({ disabled, onClick }: ISendATestButtonProps) {
	const { colors } = useTheme();
	return (
		// Moved unchanged from the campaign recipients panel; components-v2 Button has no variant with this look.
		<button className={css(styleSheet.sendATestButton)} disabled={disabled} onClick={onClick} type='button'>
			<PaperPlaneIcon style={{ color: colors.primary.main }} />
			<span>Send a Test</span>
		</button>
	);
}
